import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Collections, Elements, Objects, Parts, Types} from "components";

import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import {Link, Prompt} from "react-router-dom";
import TransactionObject from "components/TransactionObject";
import {toast} from "react-toastify";
import UniversalModalOverride from "components/UniversalModalOverride";
import WarningAlert from "components/Elements/DispositionPendingWarningAlert";
import {confirmAlert} from "react-confirm-alert";
import APPCONFIG from "constants/Config";
import {TextField} from "@material-ui/core";
import {mark4473PrintExpected} from "utils/unprinted4473Reminder";

//import {Warning} from "@material-ui/icons";


/**
 *  @property {Dispositions_Pendings_Object} y
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */
class DispositionPending extends TransactionObject {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
		// noinspection JSPrimitiveTypeWrapperUsage
		this.model.properties.location.required = true;

		this.state.employeeSign = false;
		this.state.enableCompleteButton = true;
		this.afterEventSave = this.setNewObject('event');
		this.state.showIds = false;
		this.state.showNICIds = false;
		//TODO: make is_military function properly on componentDidMount or update
		this.state.is_military = false;
		this.state.nullLongGuns = [];
		this.state.manager_approval = false;
		this.state.manager_ignore_message = '';
		this.state.manager_ignore_warning = '';
		this.state.manager_password = '';
		this.state.unsavedChanges = false;
		this.state.enableLogging = false;
		this.state.ignore_unequal_dates = false;
		this.state.extensionInstalled = false;
	}

	componentDidMount() {
		super.componentDidMount()
		window.addEventListener('beforeunload', this.handleBeforeUnload);
		if (this.state.disposition_pending_itemss.length !== 0) {
			let nullLongGuns = this.state.disposition_pending_itemss.map((item) => {
				if ((item.products.semi_auto_w_detach === null) && (item.products.type === "Rifle" || item.products.type === "Rifle / Shotgun")) {
					return [item.products.serial_number, item.products.type, item.products]
				}
			}).filter(e => e !== undefined);
			this.setState({nullLongGuns: nullLongGuns})
		}
		if (this.state.permit_image && this.state.valid_permit === false) {
			this.setState({valid_permit: true})
		}

		// console.log('chrome', chrome);
		if(typeof chrome !== 'undefined') {
			chrome?.runtime?.sendMessage(
				'ljkmnebhaklplkjlmficiihhefpgmkap',
				{ ping: true },
				(response) => {
					if (chrome.runtime.lastError) {
					} else {
						this.setState({extensionInstalled: true});
					}
				}
			);
			chrome?.runtime?.sendMessage(
				'gkcaldngjihkfdllegnaniclnpdfcaid',
				{ ping: true },
				(response) => {
					if (chrome.runtime.lastError) {
					} else {
						this.setState({extensionInstalled: true});
					}
				}
			);
		}


	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		this.reformatGuns(prevState);
		//send form back up to parent
		if(typeof this.props.formNumber === 'function' && prevState.form !== this.state.form){
			this.props.formNumber(this.state.form);
		}
		if(prevState !== this.state && prevState.unsavedChanges === false && prevState.enableLogging === true){
			this.setState({
				unsavedChanges: true,
			});
		}
		//run enable complete button function
		if(prevState.identification_issue !== this.state.identification_issue
			|| prevState.identification_expiration !== this.state.identification_expiration
			|| prevState.nics_date !== this.state.nics_date
		){
			this.updateEnableCompleteButtonStatus();
		}

	};

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.handleBeforeUnload);
	};

	handleBeforeUnload = (event) => {
		if (this.state.unsavedChanges) {
			event.preventDefault();
			event.returnValue = '';
		}
	};

	/**
	 * The T doesn't exist before the nics date is saved, that's why two comparisons are here
	 * @param first
	 * @param second
	 * @returns {boolean}
	 */
	datesAreOnSameDay = (first, second) => {
		return (first.split("T")[0] === second.split("T")[0] || first.split("T")[0] === second.split(" ")[0]) ;
	}

	reformatGuns = (prevState) => {
		if (this.state.disposition_pending_itemss) {
			let nullLongGuns = this.state.disposition_pending_itemss.map((item) => {
				if ((item.products.semi_auto_w_detach === null) && (item.products.type === "Rifle" || item.products.type === "Rifle / Shotgun")) {
					return [item.products.serial_number, item.products.type, item.products]
				}
			}).filter(e => e !== undefined);
			if (nullLongGuns.length > 0) {
				if (prevState.nullLongGuns.length !== nullLongGuns.length) {
					this.setState({nullLongGuns: nullLongGuns})
				}
			}
		}
	}

	/**
	 * @param {Dispositions_Pendings_Object} data
	 */
	loadSelfAfter = (data) => {
		let possibleExisting = data.customers_existing && data.customers_existing.length > 0;
		if (typeof this.props.showCustomers === 'function' && possibleExisting) {
			this.props.showCustomers();
		}

		this.setState({
			'date': moment().format('YYYY-MM-DD HH:mm:ss'),
			'enableLogging' : true
		});
		this.updateEnableCompleteButtonStatus();
	};

	addProducts = async (products) => {
		await this.handleSubmit(null, true);
		this.setState({loading: true});
		products = products.filter(entry => !this.state.disposition_pending_itemss.find(
			current => current.product === entry.pkey && current.product_binary_id === entry.binary_id
		));

		if (products.length === 0) {
			this.setState({loading: false});
			return;
		}

		let teModel = new API.BuildClass(Types.Dispositions_Pendings_Items._name, API.RequestType.READ);
		//teModel.object.product = products.map(entry => entry.pkey);
		teModel.object.product = products.map(
			/**
			 * @param {Products_Object} entry
			 * @returns {string}
			 */
			(entry) => entry.binary_id + '-' + entry.pkey
		);

		teModel.parent = this.state.pkey;
		teModel.parent_binary_id = this.state.binary_id;

		try {
			let data = await teModel.submit(null, API.RequestType.CREATE);
			// noinspection JSUnresolvedVariable
			let pkeys = data.pkeys;
			let binary_ids = data.binary_ids;
			let entries = [...this.state.disposition_pending_itemss, ...products.map(product => {
				return {
					pkey: pkeys[product.pkey] || '',
					binary_id: binary_ids[product.pkey] || '',
					product: product.pkey,
					product_binary_id: product.binary_id,
					products: product,
					pawn_redemption: data.pawn_redemption
				}
			})];
			this.setState({disposition_pending_itemss: entries});
		} catch (e) {
		}
		this.setState({loading: false});
	};

	handleProcess(event, requestOverride) {
		let result = true;
		if (this.update === 'POST_COMPLETE') {
			if (this.state.disposition_pending_itemss === null || this.state.disposition_pending_itemss.length === 0) {
				API.Toast.warn('Product is required.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
				result = false;
			}
		}

		//If either is false then fail
		//Skip Transaction Object handleProcess
		if (event === null) event = {};
		event.bypassSelf = true;
		return result && super.handleProcess(event, requestOverride);
	}


	handleExtensionSubmit = async () => {
		let data = this.state;
		localStorage.removeItem("leep_hash");
		let inches = data.height_in ? data.height_in.toString() : null;
		if (inches !== null && inches.length === 1) {
			inches = '0' + inches.toString();
			this.setState({height_in: inches});
		}
		this.state.transaction_purposes = '';
		let flags = [];
		for (let i in data.disposition_pending_itemss) {
			let entry = data.disposition_pending_itemss[i];
			let isPawnRedemption = entry.pawn_redemption;
			if (['Pistol', 'Revolver', 'Derringer'].includes(entry.products.type)) {
				if (isPawnRedemption) {
					flags['isChecked7'] = true;
					this.state.is_checked7 = true;
					this.state.transaction_purposes += " Pre-Pawn of Hand Gun,"
				}
				else {

					flags['isChecked1'] = true; //Sale of Hand Gun
					this.state.is_checked1 = true;
					this.state.transaction_purposes += " Sale of Hand Gun,"
				}
			}
			if (['Rifle', 'Shotgun', 'Rifle / Shotgun'].includes(entry.products.type)) {
				if (isPawnRedemption) {

					this.state.is_checked8 = true;
					flags['isChecked8'] = true;
					this.state.transaction_purposes += " Pre-Pawn of Long Gun,"
				}
				else {
					flags['isChecked2'] = true; //Sale of Long Gun
					this.state.is_checked2 = true;
					this.state.transaction_purposes += " Sale of Long Gun,"
				}


			}
			if (['Receiver', 'Frame', 'Lower Receiver', 'NFA', 'Machine Gun', 'SBR', 'SBS', 'AOW', 'DD', 'Suppressor', 'Silencer', 'Pistol Grip Firearm'].includes(entry.products.type)) {
				if (isPawnRedemption) {
					this.state.is_checked9 = true;
					flags['isChecked9'] = true;
					this.state.transaction_purposes += " Pre-Pawn of Other,"
				}
				else {
					flags['isChecked3'] = true; //Sale of Other
					this.state.is_checked3 = true;
					this.state.transaction_purposes += " Sale of Other,"
				}
			}
		}
		let currentDisposition = data;
		currentDisposition.flags = flags;
		this.state.transaction_flag = flags;
		// currentDisposition.birth_date = moment(currentDisposition.birth_date).format('MM/DD/YYYY')
		if(inches !== null){
			currentDisposition.height = currentDisposition.height_ft + inches;
		} else {
			currentDisposition.height = currentDisposition.height_ft + "00";
		}
		this.state.height = currentDisposition.height;
		this.setState({height: currentDisposition.height});
		currentDisposition.leep = {
			leep_username: this.props.leepUsername,
			leep_password: this.props.leepPassword,
		}

		const { ssn, identification_number } = currentDisposition;
		const updatedSSN = ssn ? ssn.replace(/-/g, "") : ssn;
		const updatedIdentificationNumber = identification_number ? identification_number.replace(/\s+/g, '') : identification_number;
		this.setState({
			ssn: updatedSSN,
			identification_number: updatedIdentificationNumber
		});

		let leepLogModel = new API.BuildClass(Types.Leep_User_Logs._name, API.RequestType.CREATE);
		this.state.ethnicity = this.state.ethnicity_hispanic ? "Is Hispanic or Latino" : "Is Not Hispanic or Latino";
		this.state.race = this.state.formattedRace;
		this.state.citizenship_status = this.state.foreign_citizenship ? "Non-U.S. Citizen" : "US Citizen";


		// this.state.transaction_purposes.includes('null_') && this.state.transaction_purposes.replace('null ', '');
		let pending_hash = await this.randomHash(16);
		this.state.pending_hash = pending_hash;
		localStorage.setItem('leep_hash', pending_hash);
		localStorage.setItem('transaction_purposes', this.state.transaction_purposes);
		await leepLogModel.submit(this, API.RequestType.CREATE, true);
		// window.postMessage({
		// 	source: "fflboss",
		// 	payload: currentDisposition
		// }, "*");
	}
	handleLeepSubmit = async () => {
		this.setState({loading: true})
		await this.handleSubmit();
		await this.handleExtensionSubmit();
		await this.props.history.push('/dispositions/pendings/' + this.props.id + '/leep');
		this.setState({loading: false})
	}

	randomHash = async (length) => {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < length) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		return result;

	}

	handleSubmit = async (e, suppressToast = false, suppressProcess = false, pending = false) => {
		if (this.state.birth_date === null && !pending) {
			API.Toast.warn('Customer Birth Date is Required to Save this transaction.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
		} else {
			if (!this.state.is_military) {
				this.state.military_pcs_city = null;
				this.state.military_pcs_state = null;
				this.state.military_pcs_date = null;
				this.state.military_pcs_order_number = null;
				this.state.military_city = null;
				this.state.military_state = null;
				this.state.military_county = null;
				this.state.military_street_1 = null;
				this.state.military_street_2 = null;
				this.state.military_zip = null;
				this.state.military_pcs_basename = null;
			}
			await super.handleSubmit(e, suppressToast, suppressProcess).then();
			this.update = 'POST';
			this.setState({ unsavedChanges: false });
		}
	}

	pendingComplete = (data) => {
		this.state.signature_35 = data.signature_35;
		this.state.signature_35_date = data.signature_35_date;
		this.update = 'POST_COMPLETE';
		this.handleSubmit().then();
	};

	pendingCancel = (data) => {
		this.handleSubmit().then(() =>
		{
			this.state.signature_35 = data.signature_35;
			this.state.signature_35_date = data.signature_35_date;
			this.update = 'POST_CANCEL';
			this.handleSubmit(null, false, true, true).then();
		});
	};

	printPdf = async () => {
		let model = new API.BuildClass(Types.Dispositions_Pendings_Forms._name, API.RequestType.CREATE);
		model.object.form = 22;
		model.parent = this.state.pkey;
		model.parent_binary_id = this.state.binary_id;
		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
		}
		this.props.reloadPage();
	};

	updateEnableCompleteButtonStatus = () => {
		const exists = item => typeof item !== 'undefined';
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;

		const answerCheckList = {
			nics_denied: {
				notAlerted: (exists(object.customers) && !object.customers.nics_denied),
				alertIgnored: !!object.ignore_nics_denied
			},
			blacklist: {
				notAlerted: exists(object.customers) && !object.customers.blacklist,
				alertIgnored: !!object.ignore_blacklist
			},
			under_age: {
				notAlerted: moment().diff(object.birth_date, 'years') >= 21,
				alertIgnored: !!object.ignore_under_age
			},
			permit_future_issued: {
				notAlerted: !object.permit_date ? true : moment().isAfter(object.permit_date),
				alertIgnored: !!object.ignore_permit_future_issued
			},
			permit_expired: {
				notAlerted: !object.permit_expiration ? true : moment().isBefore(object.permit_expiration),
				alertIgnored: !!object.ignore_permit_expired
			},
			identification_future_issued: {
				notAlerted: !object.identification_issue ? true : moment().isAfter(object.identification_issue?.split("T")[0].split(" ")[0]),
				alertIgnored: !!object.ignore_identification_future_issued
			},
			identification_expired: {
				notAlerted: !object.identification_expiration ? true : moment().isBefore(object.identification_expiration),
				alertIgnored: !!object.ignore_identification_expired
			},
			expired_nics_date: {
				notAlerted: !object.nics_date ? true : moment().diff(object.nics_date, 'days') <= 30,
				alertIgnored: !!object.ignore_expired_nics_date
			},
			expired_pending_date: {
				notAlerted: !object.date ? true : moment().diff(object.date, 'days') <= 30,
				alertIgnored: !!object.ignore_expired_pending_date
			},
			out_of_state: {
				notAlerted: exists(object.location) && exists(object.locations) && (object.locations.state === object.state_of_residence && object.locations.state === object.state),
				alertIgnored: !!object.ignore_out_of_state
			},
			actual_transferee: {
				notAlerted: !!object.actual_transferee,
				alertIgnored: !!object.ignore_actual_transferee
			},
			unequal_dates: {
				notAlerted:  !(this.props.rootState.hasTwinCityPawnModule && object.nics_date && !this.datesAreOnSameDay(object.signature_14_date, object.nics_date)),
				alertIgnored: !!object.ignore_unequal_dates
			},
			actual_intention: {
				notAlerted: !(!!object.actual_intention),
				alertIgnored: !!object.ignore_actual_intention
			},
			actual_intention_felony: {
				notAlerted: !(!!object.actual_intention_felony),
				alertIgnored: !!object.ignore_actual_intention_felony
			},
			felony_indictment: {
				notAlerted: !(!!object.felony_indictment),
				alertIgnored: !!object.ignore_felony_indictment
			},
			felony_convicted: {
				notAlerted: !(!!object.felony_convicted),
				alertIgnored: !!object.ignore_felony_convicted
			},
			fugitive: {
				notAlerted: !(!!object.fugitive),
				alertIgnored: !!object.ignore_fugitive
			},
			drug_user: {
				notAlerted: !(!!object.drug_user),
				alertIgnored: !!object.ignore_drug_user
			},
			mentally_unstable: {
				notAlerted: !(!!object.mentally_stable),
				alertIgnored: !!object.ignore_mentally_stable
			},
			dishonorable_discharge: {
				notAlerted: !(!!object.dishonorable_discharge),
				alertIgnored: !!object.ignore_dishonorable_discharge
			},
			restraining_order: {
				notAlerted: !(!!object.restraining_order),
				alertIgnored: !!object.ignore_restraining_order
			},
			domestic_violence: {
				notAlerted: !(!!object.domestic_violence),
				alertIgnored: !!object.ignore_domestic_violence
			},
			renounced_citizenship: {
				notAlerted: !(!!object.renounced_citizenship),
				alertIgnored: !!object.ignore_renounced_citizenship
			},
			illegal_alien: {
				notAlerted: !(!!object.illegal_alien),
				alertIgnored: !!object.ignore_illegal_alien
			},
			nonimmigrant_visa: {
				notAlerted: !(!!object.nonimmigrant_visa),
				alertIgnored: !!object.ignore_nonimmigrant_visa
			},
			fall_within_exceptions: {
				notAlerted: !(!!object.nonimmigrant_visa),
				alertIgnored: !!object.ignore_fall_within_exceptions
			}
		}
		const checkItem = item => answerCheckList[item].notAlerted ? true : !!answerCheckList[item].alertIgnored;
		//const alertItem = item => !answerCheckList[item].notAlerted;

		let allKeysTrue = Object.keys(answerCheckList).every(
			key => {
				return checkItem(key)
			}
		);

		let hasCustomer = exists(object.customers) && object.customers !== null && object.customers !== "";
		let hasPossibleDuplicates = exists(object.customers_existing) && object.customers_existing.length > 0;
		let ignoreCustomer = object.ignore_possible_duplicate_customer === true;
		let customerIsGood = hasCustomer || (!hasPossibleDuplicates || ignoreCustomer);
		let pawnRedemptionIsGood = this.props.rootState.hasTwinCityPawnModule ? this.state.pawn_redemption !== null : true;
		let line30Signature = object.nics_response !== 'Denied' && object.nics_response !== 'Cancelled' && !object.following_denied && !object.following_cancelled && object.signature_14_date && (!moment(object.signature_14_date).isSame(moment(), 'day') && (!object.signature_22 || !moment(object.signature_22_date).isSame(moment(), 'day')));

		this.setState({enableCompleteButton: allKeysTrue && customerIsGood && !line30Signature && pawnRedemptionIsGood});
	}

	ignoreWarning = (warningName) => () => {
		//if manual 4473 module, then get approval before ignoring it
		if(this.props.rootState.hasAutoAcquisitionModule || warningName === 'ignore_unequal_dates') {
			this.toggleManagerApproval(warningName)
		} else {
			this.actualIgnoreWarning(warningName);
		}
	};

	actualIgnoreWarning = (warningName) => {
		//Function needs to run AFTER the state has confirmed changed
		//Otherwise it hits with the wrong data being read in that function
		this.setState({
			[warningName]: true
		}, this.updateEnableCompleteButtonStatus);
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if (request === 'POST_COMPLETE' && !this.props.rootState.hasCloudModule) {
			mark4473PrintExpected(data.binary_id + '-' + data.pkey);
		}
		if (request === 'POST_COMPLETE' || request === 'POST_CANCEL') {
			this.props.history.push('/dispositions/' + data.binary_id + '-' + data.pkey + '#forms');
		}
		this.update = API.RequestType.UPDATE;


	}

	sigPad = {};
	clear = () => {
		this.sigPad.clear()
	};

	handleToggleSendToKioskModal = () => {
		this.setState({sendToKioskModalOpen: !this.state.sendToKioskModalOpen});
	}

	handleAfterKiosk = () => {
		this.props.history.push('/dispositions/pendings');
	}

	isValidIdentification = () => {
		return(!this.state.identification_authority || !this.state.identification_type || !this.state.identification_number); // || (!this.state.nics_response && !this.state.national_fire_arms_act)); //
	}


	isValidTwinCityPawnIdentification = () => {
		if(this.props.rootState.hasTwinCityPawnModule) {
			return (!this.state.identification_issue || !this.state.identification_expiration)
		}
		else {
			return false;
		}
	}


	handleToggleEmployeeSign = () => {
		if(this.isValidIdentification() || this.isValidTwinCityPawnIdentification())  {
						!this.state.identification_authority && this.setState({identification_authority_error: true})
						!this.state.identification_type && this.setState({identification_type_error: true});
						!this.state.identification_number && this.setState({identification_number_error: true});
						this.props.rootState.hasTwinCityPawnModule && !this.state.identification_issue && this.setState({identification_issue: ' '})
						this.props.rootState.hasTwinCityPawnModule && !this.state.identification_expiration && this.setState({identification_expiration: ' '})
						this.handleScrollTo('identification_authority');
						//(!this.state.nics_response && !this.state.national_fire_arms_act) && this.setState({nics_response_error: true});
		}
		else if (this.state.disposition_pending_itemss.length !== 0) {
			this.setState({employeeSign: !this.state.employeeSign});
			this.handleSubmit().then();

		} else {
			toast.warn(Framework.Toast.TitledNotice("Need Products", "This transaction must contain products."), {
				position: toast.POSITION.TOP_CENTER
			});
		}
	}

	/**
	 * @param {Dispositions_Pendings_Items_Object} entry
	 * @returns {function(*, *): Promise<void>}
	 */
	updateEntry = (entry) => async (property, value) => {
		this.toggleLoading(true);
		await this.handleSubmit();
		let teModel = API.BuildClass(Types.Dispositions_Pendings_Items._name, API.RequestType.READ);
		teModel.object.pkey = entry.pkey;
		teModel.object.binary_id = entry.binary_id;
		teModel.parent = entry.disposition_pending ?? this.state.pkey;
		teModel.parent_binary_id = entry.disposition_pending_binary_id ?? this.state.binary_id;
		teModel.object.pawn_redemption = value;
		let data = await teModel.submit(null, API.RequestType.UPDATE, true);
		this.updateProduct(data.products, data, true);
		this.toggleLoading(false);
	}

	handleFileChange = (property, file) => {
		this.model.files[property] = file;
		this.setState({
			[property]: file.name,
			[property + '_error']: '',
		});
	};


	hasPawnRedemptionError = () => {
		return this.state.pawn_redemption === true && !this.state.disposition_pending_itemss.some(item => item.pawn_redemption);
	}


	handleDeletePermit = () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to Remove this Permit?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							let pModel = new API.BuildClass(Types.Customers_Permits._name, API.RequestType.DELETE)
							pModel.object.pkey = this.state.pkey;
							pModel.object.number = this.state.permit_number;
							if (this.state.customers.length > 0) {
								pModel.parent = this.state.customers.pkey
								pModel.parent_binary_id = this.state.customers.binary_id
							} else {
								pModel.parent = '999999999';
								pModel.parent_binary_id = '9999';
							}
							await pModel.submit(null, API.RequestType.DELETE);
							this.props.reloadPage();
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}


	handleScrollTo = (scrollTo) => {
		if(document.getElementsByName(scrollTo)[0].type !== "hidden"){
			document.getElementsByName(scrollTo)[0].scrollIntoView()
		} else {
			document.getElementById(scrollTo).scrollIntoView();
		}
		window.scrollBy(0, -100);
	}

	handleDeleteIdentification = () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to Remove this Identification?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							this.setState({loading: true})

							let iModel = new API.BuildClass(Types.Customers_Identifications._name, API.RequestType.DELETE)
							iModel.object.pkey = this.state.pkey;
							iModel.object.number = this.state.permit_number;
							if (this.state.customers.length > 0) {
								iModel.parent = this.state.customers.pkey
								iModel.parent_binary_id = this.state.customers.binary_id
							} else {
								iModel.parent = '999999999';
								iModel.parent_binary_id = '9999';
							}
							iModel.parent_binary_id = this.state.customers.binary_id;
							await iModel.submit(null, API.RequestType.DELETE);
							this.setState({loading: false})
							this.props.reloadPage();
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	toggleManagerApproval = (warningName) => {
		this.setState({manager_approval: !this.state.manager_approval, manager_ignore_warning: warningName, manager_ignore_message: this.getWarningMessage(warningName, this.state)});
	}

	handleManagerApproval = async () => {
		//if submit is good, then actually ignore and toggle
		let data = await this.model.submit(this, "POST_MANAGER", true);
		if(data) {
			this.actualIgnoreWarning(this.state.manager_ignore_warning);
			this.toggleManagerApproval('');
		}
		this.setState({manager_password: ''})
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	getWarningMessage = (casing, object = null) => {
		switch(casing) {
			case 'ignore_permit_expired':
				return 'The customer has an expired permit.';
			case 'ignore_identification_future_issued':
				return 'The customer has an identification issue date later than today.';
			case 'ignore_identification_expired':
				return 'The customer has an expired identification.';
			case 'ignore_expired_nics_date':
				return 'The NICS date is 30 or more days old.';
			case 'ignore_expired_pending_date':
				return 'This Pending 4473 was started more than 30 days ago.';
			case 'ignore_possible_duplicate_customer':
				return 'This is possibly an existing customer. Please "Existing Customer Match" tab to resolve.';
			case 'ignore_actual_intention':
				return 'The customer selected "Yes" to Question 21.n, indicating this person is intending to purchase for another person.';
			case 'ignore_actual_intention_felony':
				return 'The customer selected "Yes" to Question 21.b, indicating this person is intending to dispose of any firearms in furtherance of a felony.';
			case 'ignore_felony_indictment':
				return 'The customer selected "Yes" to Question 21.c, indicating this person is under indictment.';
			case 'ignore_felony_convicted':
				return 'The customer selected "Yes" to Question 21.d, indicating this person has been convicted of a felony.';
			case 'ignore_fugitive':
				return 'The customer selected "Yes" to Question 21.e, indicating this person is a fugitive from justice.'
			case 'ignore_drug_user':
				return 'The customer selected "Yes" to Question 21.f, indicating this person is a user of an illicit substance.'
			case 'ignore_mentally_stable':
				return 'The customer selected "Yes" to Question 21.g, indicating this person has been adjudicated mentally defective.'
			case 'ignore_dishonorable_discharge':
				return 'The customer selected "Yes" to Question 21.h, indicating this person has been dishonorably discharged.';
			case 'ignore_restraining_order':
				return 'The customer selected "Yes" to Question 21.i, indicating this person is subject to a court restraining order.';
			case 'ignore_domestic_violence':
				return 'The customer selected "Yes" to Question 21.j, indicating this person has been convicted of a misdemeanor crime of domestic violence.';
			case 'ignore_renounced_citizenship':
				return 'The customer selected "Yes" to Question 21.k, indicating this person has renounced a United States citizenship.';
			case 'ignore_illegal_alien':
				return 'The customer selected "Yes" to Question 21.l, indicating this person is an illegal alien.';
			case 'ignore_nonimmigrant_visa':
				return 'The customer selected "Yes" to Question 21.m.1, indicating this person is a non-immigrant visa alien.';
			case 'ignore_fall_within_exceptions':
				return object.fall_within_exceptions
					? 'The customer selected "Yes" to Question 21.m.2, indicating this person falls within one of the exceptions set forth in the instructions. The licensee must complete Question 26.d on the printed 4473.'
					: 'The customer selected "No" to Question 21.m.2, indicating this person does not fall within any of the exceptions set forth in the instructions.';
			case 'ignore_permit_future_issued':
				return 'The customer has a permit issue date later than today.';
			case 'ignore_out_of_state':
				return `The customer is potentially from out of state (${object.state_of_residence === object.locations.state ? `Residency Address State is ${object.state}` : `State of Residency is ${object.state_of_residence}`}) and may not be able to purchase the requested firearm(s).`;
			case 'ignore_under_age':
				return 'The customer is under ' + moment().diff(object.birth_date, 'years') < 18 ? '18' : '21' + ' years old and may not be eligible to purchase the requested firearm(s).';
			case 'ignore_actual_transferee':
				return object === false ?
					'The customer selected "No" to Question 21.a, indicating this person is not the actual buyer.' :
					'WARNING: QUESTION 21.a HAS NOT BEEN FILLED OUT. MAKE SURE THE FOLLOWING EXCEPTION APPLIES: ' +
					'Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may proceed to question 21.b.';
			case 'ignore_blacklist':
				return <span>This customer has been added to your blacklist with the following reason: <strong>"{object.customers.blacklist_reason}"</strong>. This warning will appear on any future dispositions unless they are removed from the list.</span>;
			case 'ignore_nics_denied':
				return 'This customer has received a denied on a previous disposition and was automatically added to the NICS Denied list. ' +
					'Customers who are denied in a NICS background check will be automatically added to the NICS denied list and a warning will appear on ' +
					'any future dispositions unless they are removed from the list. An embossed overturn appeal certificate is required to run a background ' +
					'check for a person previously denied by NICS.';
			case 'ignore_unequal_dates':
				return 'Fields 23 (Certification Date) does not match 27A (NICS date). Manager Approval is required.';
			default: return '';
		}
	}


	handleMyTextFieldPropertyUpdate = (property, value) => {
		this.handleTextFieldPropertyUpdate(property, value);
		Promise.resolve().then(() => {
			this.updateEnableCompleteButtonStatus();
		});
	}

	form = () => {
		/** @type {Dispositions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;

		let borderStates = ["AZ", "TX", "NM", "CA"];
		return (
			<div>
				<Prompt
					when={this.state.unsavedChanges}
					message={(location, action) => {
						const lastSegment = location.pathname.split('/').pop();
						if (location.hash === "" && lastSegment !== 'leep') {
							return 'Navigating away will discard any unsaved changes within this pending 4473.';
						}
					}}
				/>
				<fieldset>

					{/*Manager Approval Modal*/}
					<Modal
						isOpen={this.state.manager_approval}
						toggle={this.toggleManagerApproval}
						size={'md'}
						backdrop={true}>
						<form onSubmit={this.handleManagerApproval}>
							<ModalHeader toggle={this.toggleManagerApproval}>
								Manager Approval
							</ModalHeader>
							<ModalBody>
								<p>Please enter a manager's password in order to continue to ignore the reason below:</p>
								<p><b>{this.state.manager_ignore_message}</b></p>

								<TextField
									fullWidth
									margin="dense"
									variant="outlined"
									name="manager_password"
									label="Manager Password"
									value={this.state.manager_password}
									onChange={this.handleDataChange}
									type={"password"}
								/>
							</ModalBody>
							<ModalFooter>
								<Button color="secondary" onClick={this.toggleManagerApproval}>Cancel</Button>
								<Button color="info" onClick={this.handleManagerApproval}>Submit</Button>
							</ModalFooter>
						</form>
					</Modal>

					{/*#region Section C*/}

					<h4 className="section-title" style={{textAlign: 'center'}}>
						Section C - Must Be Completed By Transferor/Seller Prior To The Transfer Of The Firearm(s)
						<Button onClick={this.printPdf} size={"sm"} color="primary"
						        className={'pull-right'} style={{marginRight: '-6px'}}>
							<span><i className="fa fa-file-pdf-o"/>
								<span className="hidden-xs">&nbsp;Generate/Print Interim 4473</span>
							</span>
						</Button>
					</h4>

					{/*region Warnings*/}

					{this.state.loaded &&
						<div className={'warnings'} data-cy={"warnings"}>
							{!object.ignore_nics_denied && object.customers && object.customers.nics_denied &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_nics_denied')}
									warningMessage={this.getWarningMessage('ignore_nics_denied')}
								/>}

							{!object.ignore_blacklist && object.customers && object.customers.blacklist &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_blacklist')}
									warningMessage={this.getWarningMessage('ignore_blacklist', object)}
								/>}


							{!this.state.extensionInstalled &&
								<Alert color="warning">
									⚠️ Notice: The FFL Boss Extension Is NOT Installed, You will not have access to autofill features with ATF eForms and FBI's LEEP background check. <a target="_blank" href={'https://chromewebstore.google.com/detail/ffl-boss-2-click-backgrou/gkcaldngjihkfdllegnaniclnpdfcaid?hl=en'}>Click here to install</a>
								</Alert>
							}

							{!object.birth_date &&
								<WarningAlert
									hideButton={true}
									warningName={'Missing Date of Birth'}
									warningMessage={'Customers Date of Birth is missing. Please edit the disposition and add the date of birth.'}
								/>}

							{object.identification_type_error &&
								<WarningAlert
									hideButton={true}
									warningName={'Missing Identification Type'}
									warningMessage={'Identification Type is missing. Please add the corresponding Identification Type.'}
								/>}

							{object.identification_number_error &&
								<WarningAlert
									hideButton={true}
									warningName={'Missing Identification Number'}
									warningMessage={'Identification Number is missing. Please add the corresponding Identification Number.'}
								/>}

							{this.props.rootState.hasTwinCityPawnModule && object.pawn_redemption === null &&
								<WarningAlert
									hideButton={true}
									warningName={'Missing Pawn Redemption'}
									warningMessage={'Pawn Redemption selection is blank. Please choose yes or no.'}
								/>}


							{object.identification_authority_error &&
								<WarningAlert
									hideButton={true}
									warningName={'Missing Identification Authority'}
									warningMessage={'Identification Authority is missing. Please add the corresponding Identification Authority.'}
								/>}

							{/*{object.nics_response_error &&*/}
							{/*	<WarningAlert*/}
							{/*		hideButton={true}*/}
							{/*		warningName={'Missing Nics Response'}*/}
							{/*		warningMessage={'Nics Response is missing. Please add the corresponding Nics Response.'}*/}
							{/*	/>}*/}

							{!object.ignore_unequal_dates && this.props.rootState.hasTwinCityPawnModule && object.nics_date && !this.datesAreOnSameDay(object.signature_14_date, object.nics_date) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_unequal_dates')}
									warningName={'Field 23 does not match 27A'}
									warningMessage={this.getWarningMessage('ignore_unequal_dates')}
								/>}

							{!object.ignore_under_age && moment().diff(object.birth_date, 'years') < 21 &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_under_age')}
									warningName={'Under Age'}
									warningMessage={this.getWarningMessage('ignore_under_age', object)}
								/>}

							{!object.ignore_permit_future_issued && moment().isBefore(object.permit_date) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_permit_future_issued')}
									warningName={'Bad Permit Issued Date'}
									warningMessage={this.getWarningMessage('ignore_permit_future_issued')}
								/>}

							{!object.ignore_permit_expired && moment().isAfter(object.permit_expiration) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_permit_expired')}
									warningName={'Permit Expired'}
									warningMessage={this.getWarningMessage('ignore_permit_expired')}
								/>}

							{!object.ignore_identification_future_issued && moment().isBefore(object.identification_issue?.split("T")[0].split(" ")[0]) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_identification_future_issued')}
									warningName={'Bad Identification Issued Date'}
									warningMessage={this.getWarningMessage('ignore_identification_future_issued')}
								/>}

							{!object.ignore_identification_expired && moment().isAfter(object.identification_expiration) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_identification_expired')}
									warningName={'Identification Expired'}
									warningMessage={this.getWarningMessage('ignore_identification_expired')}
								/>}

							{!object.ignore_expired_nics_date && moment().diff(object.nics_date, 'days') > 30 &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_expired_nics_date')}
									warningName={'NICS Date Past 30 Days'}
									warningMessage={this.getWarningMessage('ignore_expired_nics_date')}
								/>}

							{!object.ignore_expired_pending_date && moment().diff(object.date, 'days') > 30 &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_expired_pending_date')}
									warningName={'Old Pending 4473 Date'}
									warningMessage={this.getWarningMessage('ignore_expired_pending_date')}
								/>}

							{!object.ignore_possible_duplicate_customer && !object.customers && object.customers_existing && object.customers_existing.length > 0 &&
								<WarningAlert
									// hideButton={true}
									onAlertDismiss={this.ignoreWarning('ignore_possible_duplicate_customer')}
									warningName={'Possible Existing Customer'}
									warningMessage={this.getWarningMessage('ignore_possible_duplicate_customer')}
								/>}

							{!object.ignore_out_of_state && object.location && object.locations && (object.locations.state !== object.state_of_residence || object.locations.state !== object.state) &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_out_of_state')}
									warningName={'Out Of State'}
									warningMessage={this.getWarningMessage('ignore_out_of_state', object)}
								/>}

							{!object.ignore_actual_transferee && !object.actual_transferee &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_actual_transferee')}
									warningName={'Question 21.a'}
									warningMessage={this.getWarningMessage('ignore_actual_transferee', object.actual_transferee)}
								/>}

							{!object.ignore_actual_intention_felony && object.actual_intention_felony &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_actual_intention_felony')}
									warningName={'Question 21.b'}
									warningMessage={this.getWarningMessage('ignore_actual_intention_felony')}
								/>}

							{!object.ignore_felony_indictment && object.felony_indictment &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_felony_indictment')}
									warningName={'Question 21.c'}
									warningMessage={this.getWarningMessage('ignore_felony_indictment')}
								/>}

							{!object.ignore_felony_convicted && object.felony_convicted &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_felony_convicted')}
									warningName={'Question 21.d'}
									warningMessage={this.getWarningMessage('ignore_felony_convicted')}
								/>}

							{!object.ignore_fugitive && object.fugitive &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_fugitive')}
									warningName={'Question 21.e'}
									warningMessage={this.getWarningMessage('ignore_fugitive')}
								/>}

							{!object.ignore_drug_user && object.drug_user &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_drug_user')}
									warningName={'Question 21.f'}
									warningMessage={this.getWarningMessage('ignore_drug_user')}
								/>}

							{this.hasPawnRedemptionError() &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_pawn_redemption')}
									warningName={'Pawn Redemption Error'}
									warningMessage={'Pawn redemption is selected but no items are toggled for pawn redemption'}
								/>}

							{!object.ignore_mentally_stable && object.mentally_stable &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_mentally_stable')}
									warningName={'Question 21.g'}
									warningMessage={this.getWarningMessage('ignore_mentally_stable')}
								/>}

							{!object.ignore_dishonorable_discharge && object.dishonorable_discharge &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_dishonorable_discharge')}
									warningName={'Question 21.h'}
									warningMessage={this.getWarningMessage('ignore_dishonorable_discharge')}
								/>}

							{!object.ignore_restraining_order && object.restraining_order &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_restraining_order')}
									warningName={'Question 21.i'}
									warningMessage={this.getWarningMessage('ignore_restraining_order')}
								/>}

							{!object.ignore_domestic_violence && object.domestic_violence &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_domestic_violence')}
									warningName={'Question 21.j'}
									warningMessage={this.getWarningMessage('ignore_domestic_violence')}
								/>}

							{!object.ignore_renounced_citizenship && object.renounced_citizenship &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_renounced_citizenship')}
									warningName={'Question 21.k'}
									warningMessage={this.getWarningMessage('ignore_renounced_citizenship')}
								/>}

							{!object.ignore_illegal_alien && object.illegal_alien &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_illegal_alien')}
									warningName={'Question 21.l'}
									warningMessage={this.getWarningMessage('ignore_illegal_alien')}
								/>}

							{!object.ignore_nonimmigrant_visa && object.nonimmigrant_visa &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_nonimmigrant_visa')}
									warningName={'Question 21.m.1'}
									warningMessage={this.getWarningMessage('ignore_nonimmigrant_visa')}
								/>}


							{!object.ignore_fall_within_exceptions && object.nonimmigrant_visa &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_fall_within_exceptions')}
									warningName={'Question 21.m.2'}
									warningMessage={this.getWarningMessage('ignore_fall_within_exceptions', object)}
								/>}


							{!object.ignore_actual_intention && object.actual_intention &&
								<WarningAlert
									onAlertDismiss={this.ignoreWarning('ignore_actual_intention')}
									warningName={'Question 21.n'}
									warningMessage={this.getWarningMessage('ignore_actual_intention')}
								/>}

							{borderStates.includes(object.locations.state) ? this.state.nullLongGuns?.map((gun, i) =>
								<span>
									<WarningAlert
										key={'w' + i}
										onAlertDismiss={this.toggle(['productUpdate' + 'w' + i])}
										warningName={'Product Data Error'}
										warningMessage={`Product with serial number "${gun[0]}" is a ${gun[1]} that is missing the "Semi Auto With Attachable Magazine" field.`}
										noIgnore={"View"}
									/>
									<UniversalModalOverride
										key={'um' + i}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"Product"}
										id={gun[2].pkey}
										binary_id={gun[2].binary_id}
										object={Objects.ProductUpdate}
										objectProps={{
											object: gun[2],
										}}
										toggle={this.state['productUpdate' + 'w' + i]}
										reportClose={this.handleReportModalClose('productUpdate' + 'w' + i)}
										afterSave={() => {
											this.updateProduct(gun[2], null, true);
										}}
										size={"xl"}
									/>
								</span>
							) : null}

						</div>}

					{/*endregion Warnings*/}

					<div className={"row"}>
						<div className={"col-sm"}>

							{/*#region Existing Customer*/}

							{object.customer &&
								<div className={'form-group'}>
									<h4 className="section-title">Existing Customer</h4>

									<div className={'form-group'}>
										<div className="row">
											<div className="col-3">
												<span className="input-label">Customer</span>
											</div>
											<div className="col-9 d-flex">
												{object.customer ?
													<Link to={'/customers/' + object.binary_id + "-" + object.customer} target={'_blank'}>
														<Button style={{marginRight: '4px'}} size={"md"} outline
														        color="green-meadow">
															<i className={"fa fa-search"}/>
														</Button>
													</Link>
													: null}
												<div className={'flex-grow-1'}>
													<Framework.Elements.Select
														shouldLoad={this.state.loaded}
														update={this.handleSelectPropertyUpdate}
														property={properties.customer}
														value={object.customer}
														binary_id={object.customer_binary_id}
														error={object.customer_error}
														object={object.customers}
														text={'name_first&name_last'}
														nullable={false}
														disabled={true}
														//TODO: Updated selects default sort by pkey this overrides unable to test at this time (just needs to be tested)
														//sort={'name_first&name_last'}
													/>
												</div>
											</div>
										</div>
									</div>

								</div>
							}

							{/*#endregion Existing Customer*/}

							{/*#region NICS Logic*/}

							{/*region NICS Exception*/}

							<h4 className="section-title">NICS Exception</h4>

							<div className={'form-group'}>
								<div className={'row'}>
									<div className={'col-6'}>
										<span className={'input-label'}>N.F.A firearm(s)</span>
									</div>
									<div className={'col-6 text-right'}>
										<Framework.Elements.ButtonSwitch
											property={properties.national_fire_arms_act}
											value={object.national_fire_arms_act}
											error={object.national_fire_arms_act_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={'form-group'}>
								<div className={'row'}>
									<div className={'col-6'}>
										<span className={'input-label'}>or Valid Permit</span>
									</div>
									<div className={'col-6 text-right'}>
										<Framework.Elements.ButtonSwitch
											property={properties.valid_permit}
											value={object.valid_permit}
											error={object.valid_permit_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*endregion*/}

							{/*region (Valid Permit TRUE)*/}

							{/*if true display these for valid_permit*/}
							{object.valid_permit === true ?
								<div>
									<div className={"section-title"}>
										<h4 className="section-title">Permit </h4>
										{(object.permit_type || object.permit_number || object.permit_image || object.permit_image_back || object.permit_date)
											&& <Button color="danger" onClick={this.handleDeletePermit}>Remove Permit</Button>}
										{object.valid_permit &&
											<Button color="info" onClick={() => (this.setState({showNICIds: !this.state.showNICIds}))}> Photo
												ID</Button>}
									</div>
									<div className={'form-group'}>
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.permit_state}
											value={object.permit_state}
											error={object.permit_state_error}
											model={Types.States._name}
											id={'short'}
											nullable={false}
											limit={null}
										/>
									</div>
									<div className={'form-group'}>
										<Framework.Elements.TextField
											property={properties.permit_type}
											value={object.permit_type}
											error={object.permit_type_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className={'form-group'}>
										<Framework.Elements.Date
											property={properties.permit_date}
											value={object.permit_date}
											error={object.permit_date_error}
											label={"Permit Issued Date"}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className={'form-group'}>
										{/*TODO: #masonAsk*/}
										<Framework.Elements.Date
											property={properties.permit_expiration}
											value={object.permit_expiration}
											error={object.permit_expiration_error}
											label={"Permit Expiration Date"}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className={'form-group'}>
										<Framework.Elements.TextField
											property={properties.permit_number}
											value={object.permit_number}
											error={object.permit_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									{(this.state.showNICIds || this.state.permit_image || this.state.permit_image_back) && <div className={"row"}>
										<div>
											Upload a copy of the permit for future reference and verification<br/>

										</div>
										<div className={"col-lg form-group"}>
											<h4 className="section-title">Front</h4>
											{object.permit_image ?
												<span>Current Image - <b>{object.permit_image}</b><br/><i>Upload a new
													file to
													replace the old one.</i></span>
												: null}
											<Framework.Elements.DropZone
												property={properties.permit_image}
												value={object.permit_image}
												error={object.permit_image_error}
												update={this.handleFileChange}
											/>
											{object.permit_image && <div>
												<img
													src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + (object.customers ? (object.customers.binary_id + '-' + object.customers.pkey) : '0001-9999999') + '/permits/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.permit_image}
													alt={object.permit_image}
													style={{maxWidth: '100%'}}
												/>
											</div>}
										</div>
										<div className={"col-lg form-group"}>
											<h4 className="section-title">Back</h4>
											{object.permit_image_back ?
												<span>Current Image - <b>{object.permit_image_back}</b><br/><i>Upload a new
													file to
													replace the old one.</i></span>
												: null}
											<Framework.Elements.DropZone
												property={properties.permit_image_back}
												value={object.permit_image_back}
												error={object.permit_image_back_error}
												update={this.handleFileChange}
											/>
											{object.permit_image_back && <div>
												<img
													src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + (object.customers ? (object.customers.binary_id + '-' + object.customers.pkey) : '0001-9999999') + '/permits/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.permit_image_back}
													alt={object.permit_image_back}
													style={{maxWidth: '100%'}}
												/>
											</div>}
										</div>

									</div>}
								</div> : null
							}

							{/*endregion*/}
							<div className="section-title">
								<h4 className="section-title">Identification</h4>
								{(object.identification_authority || object.identification_number || object.identification_type || object.identification_image || object.identification_image_back)
									&& <Button style={{float: 'right'}} color="danger" onClick={this.handleDeleteIdentification}>Remove
										Identification</Button>}
								<Button color="info" onClick={() => (this.setState({showIds: !this.state.showIds}))}>Photo ID</Button>
							</div>

							{/*<h4 className="section-title">Identification*/}
							{/*	*/}
							{/*	</h4>*/}
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.identification_authority}
									value={object.identification_authority}
									error={object.identification_authority_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.identification_type}
											value={object.identification_type}
											error={object.identification_type_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.identification_number}
											value={object.identification_number}
											error={object.identification_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className={"row"}>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.Date
											property={properties.identification_issue}
											value={object.identification_issue}
											error={object.identification_issue_error}
											label={"Issued Date"}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.Date
											property={properties.identification_expiration}
											value={object.identification_expiration}
											error={object.identification_expiration_error}
											label={"Expiration Date"}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.alternate_documentation}
									value={object.alternate_documentation}
									error={object.alternate_documentation_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.nonimmigrant_visa_prohibition}
									value={object.nonimmigrant_visa_prohibition}
									error={object.nonimmigrant_visa_prohibition_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{(this.state.showIds || this.state.identification_image || this.state.identification_image_back) &&
								<div className={"row"}>
									<div>
										Upload a copy of the identification for future reference and verification<br/>
									</div>

									<div className={"col-lg form-group"}>
										<h4 className="section-title">Front</h4>
										{object.identification_image ?
											<span>Current Image - <b>{object.identification_image}</b><br/><i>Upload a new
												file to
												replace the old one.</i></span>
											: null}
										<Framework.Elements.DropZone
											property={properties.identification_image}
											value={object.identification_image}
											error={object.identification_image_error}
											update={this.handleFileChange}
										/>
										{object.identification_image && <div>
											<img
												src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + (object.customers ? (object.customers.binary_id + '-' + object.customers.pkey) : '0001-9999999') + '/identifications/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.identification_image}
												alt={object.identification_image}
												style={{maxWidth: '100%'}}
											/>
										</div>}
									</div>
									<div className={"col-lg form-group"}>
										<h4 className="section-title">Back</h4>
										{object.identification_image_back ?
											<span>Current Image - <b>{object.identification_image_back}</b><br/><i>Upload a new
												file to
												replace the old one.</i></span>
											: null}
										<Framework.Elements.DropZone
											property={properties.identification_image_back}
											value={object.identification_image_back}
											error={object.identification_image_back_error}
											update={this.handleFileChange}
										/>
										{object.identification_image_back && <div>
											<img
												src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + (object.customers ? (object.customers.binary_id + '-' + object.customers.pkey) : '0001-9999999') + '/identifications/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.identification_image_back}
												alt={object.identification_image_back}
												style={{maxWidth: '100%'}}
											/>
										</div>}
									</div>
								</div>}
							{/*region NFA FALSE && Valid Permit FALSE*/}

							{/*//display these if the nfa firearms is false and valid_permit is false*/}
							{!object.national_fire_arms_act && !object.valid_permit &&
								<div>

									{/*region LEEP Background Check*/}

									<div className={'form-group'}>
										<h4 className="section-title">LEEP Background Check</h4>
									</div>
									<div className={'form-group'}>
										<p style={{fontSize: '11px'}}>
											Once you complete the background check you will be brought back to this page with the results.
										</p>
									</div>
									<div className={'form-group'}>
										<Button onClick={this.handleLeepSubmit}
										        color={'primary'}>Use Assisted LEEP</Button>
									</div>
									<div className={'form-group'}>
										<p style={{fontSize: '11px'}}>
											Click <a href={'https://www.cjis.gov/'} target={'_blank'}>here </a>to setup a LEEP account for
											online background checks.
										</p>
									</div>
								</div>}

							{/*endregion*/}

							{/*region NICS (or State POC)*/}
							{!object.national_fire_arms_act && (!object.valid_permit || this.props.rootState.hasUtahModule) &&
								<div>
									<h4 className="section-title">NICS (or State POC) Initial Response - 27 A, B, C</h4>
									<div className={'form-group'}>
										<p style={{fontSize: '11px'}}>
											Date the transferee’s/buyer’s identifying information in Section B was transmitted to NICS or the
											appropriate State agency:
										</p>
									</div>
									<div className={"row"}>
										<div className={"col-sm"}>
											<div className="form-group">
												<Framework.Elements.Date
													label={"Response Date"}
													property={properties.nics_date}
													value={object.nics_date}
													error={object.nics_date_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-sm"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={'Number'}
													property={properties.nics_number}
													value={object.nics_number}
													error={object.nics_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={'form-group'}>

										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											property={properties.nics_response}
											value={object.nics_response}
											error={object.nics_response_error}
											model={Types.Nics_Responses._name}
											id={'name'}
											label={"NICS Response"}
											nullable={true}
											limit={null}
										/>

									</div>

									{/*endregion*/}

									{/*region nics_response === 'Delayed'*/}

									<div>
										{/*region The firearm(s) may be transferred on*/}
										{object.nics_response === "Delayed" &&
											<div>
												<h4 className="section-title">The firearm(s) may be transferred on</h4>
												<div className={'form-group'}>
													<p style={{fontSize: '11px'}}>
														The firearm(s) may be transferred on <strong>the below date</strong> if State law permits
														(optional)
													</p>
												</div>
												<div className="form-group">
													<Framework.Elements.Date
														property={properties.mdi_date}
														value={object.mdi_date}
														error={object.mdi_date_error}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
											</div>
										}

										{/*endregion*/}



										{/*endregion*/}


										{/*endregion*/}
									</div>

									{/*endregion*/}

								</div>}

							{/*endregion*/}

							{/*endregion NICS Logic*/}

						</div>
						<div className={"col-sm"}>
							<div className={'form-group'}>

								{/*#region Disposition Details*/}

								<h4 className="section-title">Disposition Details</h4>

								<Parts.SelectLocation
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									locations={this.props.locations}
									states={this.props.states}
									filter={this.filterLocationOptions}
									disabled={!!object.location}
								/>

								<Parts.TransactionDetails
									history={this.props.history}
									locations={this.props.locations}
									states={this.props.states}
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									onTextUpdate={(property, value) => this.handleMyTextFieldPropertyUpdate(property, value)}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									afterEventSave={this.afterEventSave}
									isDisposition={true}
									isNew={true}
								/>

								{/*#endregion*/}

								{/*#region Identification*/}
								{/*region Delayed Response*/}

								<h4 className="section-title">NICS Following Responses - 27 D</h4>
								<div className={'form-group'}>
									<p style={{fontSize: '11px'}}>
										Prior to transfer the following response(s) was/were later provided by NICS or the appropriate State
										agency:
									</p>
								</div>
								<div className={"row"}>
									<div className={"col-6"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.following_proceed !== null && object.following_proceed !== '' ? object.following_proceed : false}
												property={properties.following_proceed}
												error={object.following_proceed_error}
												update={() => (this.setState({following_proceed: !this.state.following_proceed}))}
												color="primary"
												label={'Proceed'}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"Proceed Date"}
												property={properties.following_proceed_date}
												value={object.following_proceed_date}
												error={object.following_proceed_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-6"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.following_denied !== null && object.following_denied !== '' ? object.following_denied : false}
												property={properties.following_denied}
												error={object.following_denied_error}
												update={() => (this.setState({following_denied: !this.state.following_denied}))}
												color="primary"
												label={'Denied'}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"Denied Date"}
												property={properties.following_denied_date}
												value={object.following_denied_date}
												error={object.following_denied_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-6"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.following_cancelled !== null && object.following_cancelled !== '' ? object.following_cancelled : false}
												property={properties.following_cancelled}
												error={object.following_cancelled_error}
												update={() => (this.setState({following_cancelled: !this.state.following_cancelled}))}
												color="primary"
												label={'Cancelled'}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"Cancelled Date"}
												property={properties.following_cancelled_date}
												value={object.following_cancelled_date}
												error={object.following_cancelled_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-6"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.overturned !== null && object.overturned !== '' ? object.overturned : false}
												property={properties.overturned}
												error={object.overturned_error}
												update={() => (this.setState({overturned: !this.state.overturned}))}
												color="primary"
												label={'Overturned'}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"Overturned Date"}
												property={properties.overturned_date}
												value={object.overturned_date}
												error={object.overturned_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-12"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.no_response !== null && object.no_response !== '' ? object.no_response : false}
												property={properties.no_response}
												error={object.no_response_error}
												update={() => (this.setState({no_response: !this.state.no_response}))}
												color="primary"
												label={'No response within 3 business days'}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-12"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.delayed_response !== null && object.delayed_response !== '' ? object.delayed_response : false}
												property={properties.delayed_response}
												error={object.delayed_response_error}
												update={() => (this.setState({delayed_response: !this.state.delayed_response}))}
												color="primary"
												label={'Under 21 - Additional Delay'}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"Received On Date"}
												property={properties.delayed_under_21_date}
												value={object.delayed_under_21_date}
												error={object.delayed_under_21_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className="form-group">
											<Framework.Elements.Date
												label={"May Transfer On Date"}
												property={properties.delayed_date}
												value={object.delayed_date}
												error={object.delayed_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-12"}>
										<div className="form-group" style={{marginTop: -5}}>
											<Framework.Elements.Checkbox
												value={object.following_under_21_no_response !== null && object.following_under_21_no_response !== '' ? object.following_under_21_no_response : false}
												property={properties.following_under_21_no_response}
												error={object.following_under_21_no_response_error}
												update={() => (this.setState({following_under_21_no_response: !this.state.following_under_21_no_response}))}
												color="primary"
												label={'Under 21 - No response within 10 days after delay'}
											/>
										</div>
									</div>
								</div>
								
								<h4 style={{'margin-top': '25px'}} className="section-title">Military Address & PCS Orders <div className="form-group">
								</div>
								</h4>
								<div>
									<div className={"row"}>
										<div className={"col-10"}>
											<span className="input-label">Active Member of the Military</span>

											<div className={"row"}>
												<div className={"col-sm"}>
													<div className="form-group">
														<Framework.Elements.ButtonSwitch
															property={properties.is_military}
															value={object.is_military}
															error={object.is_military_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
												{this.state.is_military && <div className={"col-sm"}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'Military PCS Base Name'}
															property={properties.military_pcs_basename}
															value={object.military_pcs_basename}
															error={object.military_pcs_basename_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>}
											</div>
										</div>

										{this.state.is_military && <div className={"col-10"}>
											{/*PCS */}
											<div className={"row"}>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'Military PCS City'}
															property={properties.military_pcs_city}
															value={object.military_pcs_city}
															error={object.military_pcs_city_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.Select
															shouldLoad={true}
															update={this.handleSelectPropertyUpdate}
															property={properties.military_pcs_state}
															value={object.military_pcs_state}
															error={object.military_pcs_state_error}
															model={Types.States._name}
															id={'short'}
															label={"Military PCS State"}
															nullable={true}
															limit={null}
														/>
													</div>
												</div>
											</div>
											<div className={"row"}>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.Date
															label={'Military PCS Date'}
															property={properties.military_pcs_date}
															value={object.military_pcs_date}
															error={object.military_pcs_date_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'Military PCS Order #'}
															property={properties.military_pcs_order_number}
															value={object.military_pcs_order_number}
															error={object.military_pcs_order_number_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
											</div>
										</div>
										}

									</div>
								</div>

								{this.state.is_military && <section id={"military_address"}>
									<h4 className="section-title">Military Address</h4>
									<div className={"row"}>
										<div className={"col-7"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.military_street_1}
													value={object.military_street_1}
													error={object.military_street_1_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-5"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.military_street_2}
													value={object.military_street_2}
													error={object.military_street_2_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={"row"}>
										<div className={"col-7"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.military_city}
													value={object.military_city}
													error={object.military_city_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-5"}>
											<div className="form-group">
												<Framework.Elements.Select
													shouldLoad={this.state.loaded}
													update={this.handleSelectPropertyUpdate}
													property={properties.military_state}
													value={object.military_state}
													error={object.military_state_error}
													id={'short'}
													model={Types.States._name}
													nullable={true}
													limit={null}
												/>
											</div>
										</div>
									</div>
									<div className={"row"}>
										<div className={"col-7"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.military_zip}
													value={object.military_zip}
													error={object.military_zip_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-5"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.military_county}
													value={object.military_county}
													error={object.military_county_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
								</section>}

								{(this.props.rootState.hasMichiganRIModule || this.props.rootState.hasRIComboModule) && <section id={"ri-060"}>
									<h4 className="section-title">Michigan RI-060 Information</h4>
									<div>
										<div className={"row"}>
											<div className="col-6">
												<Framework.Elements.TextField
													label={'Mcoles # (If Applicable)'}
													property={properties.mcoles_number}
													value={object.mcoles_number}
													error={object.mcoles_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
											<div className="col-6">
												<Framework.Elements.TextField
													label={'CPL # (If Applicable)'}
													property={properties.cpl_number}
													value={object.cpl_number}
													error={object.cpl_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>

										</div>
									</div> </section>}

								{/*#endregion*/}

							</div>
						</div>
						<div className={"col-sm"}>
							<div className={'form-group'}>

								{/*#region Items Disposed of*/}

								<h4 className="section-title">
									Items
									<div className="pull-right">
										<Tooltip
											title="Products you have previously acquired and disposed / transferred can be found here."
											aria-label="Products you have previously acquired and disposed / transferred can be found here.">
											<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary">
												<i className={"fa fa-barcode"}/>
												<span className="hidden-xs">&nbsp;&nbsp;Items</span>
											</Button>
										</Tooltip>

										<UniversalModalOverride
											locations={this.props.locations}
											states={this.props.states}
											history={this.props.history}
											name={"In Stock Products"}
											object={Collections.ProductsExisting}
											toggle={this.state.modalLookup}
											reportClose={this.handleReportProductClose}
											afterSave={this.addProducts}
											size={"xl"}
											status={"GET_IN_STOCK"}
										/>

									</div>
								</h4>

								{object.disposition_pending_itemss && object.disposition_pending_itemss.map((entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										updatePawn={object.pawn_redemption ? this.updateEntry : null}
									/>)}

								<p style={{textAlign: 'center', color: 'grey'}}><i>{object.disposition_pending_itemss.length} Total Items</i></p>
								{/*#endregion*/}

							</div>
						</div>
					</div>

					{/*#endregion Section B*/}

					{/*region Signature Warning*/}

					{object.nics_response !== 'Denied' && object.nics_response !== 'Cancelled' && !object.following_denied && !object.following_cancelled && object.signature_14_date && (!moment(object.signature_14_date).isSame(moment(), 'day') && (!object.signature_22 || !moment(object.signature_22_date).isSame(moment(), 'day'))) &&
						<Alert color="danger" style={{border: '1px solid #dca7b0', padding: '15px'}}>
							<p style={{fontSize: '14px', textAlign: 'center', marginBottom: '0'}}>
								<b style={{fontSize: '16px'}}>Line 30 Requires a Second Signature</b> - The customer digitally signed Line 22 on
								&nbsp;{moment(object.signature_14_date).format('MM/DD/YYYY')} and is now required to sign line 30 verifying all
								information is
								still correct
								before you can proceed.
								<br/>
								<Button color="green-meadow" size={"sm"} block={false}
								        onClick={this.handleToggleSendToKioskModal}>
									Send to Kiosk for Signing
								</Button>
							</p>
						</Alert>}

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						kiosks={this.props.kiosks}
						history={this.props.history}
						id={object.pkey}
						binary_id={object.binary_id}
						name={"Send to Kiosk"}
						object={Objects.SendToKiosk}
						objectProps={{
							object: object
						}}
						showModal={this.state.sendToKioskModalOpen}
						handleToggle={this.handleToggleSendToKioskModal}
						afterSave={this.handleAfterKiosk}
						hideGoTo={true}
					/>

					{/*endregion Signature Warning*/}

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>

					<UniversalModalOverride
						name={"Employee Signature"}
						locations={this.props.locations}
						states={this.props.states}
						kiosks={this.props.kiosks}
						history={this.props.history}
						object={Objects.EmployeeSign}
						toggle={this.state.employeeSign}
						size={"xl"}
						afterSave={this.pendingComplete}
						reportClose={this.reportClose('employeeSign')}
					/>
					{this.state.actual_transferee !== true && this.state.actual_transferee !== false && <Alert color="danger">
						WARNING: QUESTION 21.a HAS NOT BEEN FILLED OUT. MAKE SURE THE FOLLOWING EXCEPTION APPLIES: <br></br>
						Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may proceed to question 21.b.
					</Alert>}
				</CardContent>
				<CardActions>
					{/*<Button color="danger" onClick={this.handleDelete}>Delete</Button>*/}
					<Button style={{marginRight: 'auto'}} color="danger" onClick={this.pendingCancel}>Record & Cancel 4473</Button>

					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					<Button color="blue-hoki" onClick={this.handleSubmit}>Pause</Button>
					<Button color="green-meadow" onClick={this.handleToggleEmployeeSign} disabled={!this.state.enableCompleteButton}>Complete</Button>
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(DispositionPending);
